module.exports = __webpack_public_path__ + "static/media/circle-arrow-right-white.e31a1694.svg";